const machineSpecifications = {
  "Hot Vending Machine": {
    machineConfig: {
      length: 1100,
      height: 1965,
      width: 1710,
      weight: 640,
      rows: 8,
      columns: 4,
    },
    connectivityAndPower: {
      networkConnectionType: 'WiFi',
      powerConsumption: 4200,
    },
    screens: [
      {
        width: '32',
        height: '80',
        resolution: '1080x1920',
        displayType: 'LCD',
      },
    ],
  },
  "Pizza Vending Machine": {
    machineConfig: {
      length: 1020,
      height: 2425,
      width: 1850,
      weight: 600,
    },
    connectivityAndPower: {
      networkConnectionType: 'WiFi',
      powerConsumption: 7500,
    },
    screens: [
      {
        width: '55',
        height: '80',
        resolution: '1080x1920 ',
        displayType: 'LCD',
      },
    ],
  },
    "Return Vending Machine":{
      machineConfig: {
      length: 896,
      height: 1850,
      width: 1350,
      weight: 400,
    },
     connectivityAndPower: {
      networkConnectionType: 'WiFi',
      //powerConsumption: 7500,
    },
    screens: [
      {
        width: '27',
        height: '16.22',
        resolution: '1080x1920 ',
        displayType: 'LCD',
      },

    ]
  }
  
};

export default machineSpecifications;
